<template>
  <validation-observer v-if="aditivo" ref="validationobserver" v-slot="{ handleSubmit }">
    <b-form @submit.prevent="handleSubmit(salvarAditivo)">
      <b-card header-tag="header" class="m-3" no-body>
        <template #header>
          <h6 class="mb-0 text-center">
            <span class="titulo-sagres font-weight-bold">
              {{ isEdit ? 'Editar' : 'Cadastrar' }} Aditivo de Convênio / Outros Instrumentos Congêneres
            </span>
            <btn-voltar />
            <b-button class="float-right m-1" size="sm" type="submit">
              <font-awesome-icon icon="save" />
              Salvar
            </b-button>
          </h6>
        </template>
        <b-card-body>
          <b-row>
            <b-col cols="4">
              <b-col id="input-group-selectConvenio" cols="12">
                <span class="d-block text-left pb-1">Convênio / Outros Instrumentos Congêneres *</span>
                <validation-provider tag="div" rules="required" v-slot="validationContext" name="convenio">
                  <div id="convenioSelectWrapper"
                    :class="{ 'invalid': (validationContext.errors.length > 0) || (aditivo.IdConvenio <= 0), 'valid': (aditivo.IdConvenio > 0) }">
                    <multiselect @input="updateSelectConvenio" v-model="convenioSelecionado" open-direction="bottom"
                      :close-on-select="true" :searchable="true" deselect-label="" :allow-empty="true"
                      placeholder="SELECIONE UMA OPÇÃO" track-by="Codigo" :options="listaConvenios" label="Nome"
                      :show-labels="false">
                      <template #noOptions>
                        <small><i>Erro ao obter dados.</i></small>
                      </template>
                      <template #noResult>
                        <i>Sem resultados.</i>
                      </template>
                    </multiselect>
                    <label class="typo__label form__label" v-if="validationContext.errors.length > 0">{{
                      validationContext.errors[0] }}</label>
                  </div>
                </validation-provider>
              </b-col>
              <!-- <validation-provider rules="required|min_value:1" v-slot="validationContext" name="convênio">
                <b-form-group id="input-group-type" label-size="md" label="Convênio / Outros Instrumentos Congêneres *" label-cols="auto"
                  content-cols="12">
                  <b-form-select id="select-convenio" v-model="aditivo.IdConvenio" :options="listaConvenios"
                    :state="getValidationState(validationContext)">
                  </b-form-select>
                </b-form-group>
                <b-form-invalid-feedback id="select-convenio-live-feedback">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider> -->
            </b-col>
            <b-col cols="4">
              <validation-provider rules="required|min_value:1" v-slot="validationContext" name="naturezaAjuste">
                <b-form-group id="input-group-type" label-size="md" label="Natureza do Ajuste *" label-cols="auto"
                  content-cols="12">
                  <b-form-select id="select-naturezaAjuste" v-model="aditivo.IdNaturezaAjuste"
                    :disabled="aditivo.IdTipoTermoAditivo <= 0" :options="listaNaturezasAjuste"
                    @change="handleTipoNaturezaAjusteChange" :state="getValidationState(validationContext)">
                  </b-form-select>
                </b-form-group>
                <b-form-invalid-feedback id="select-naturezaAjuste-live-feedback">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <b-form-group class="formGroup mb-5" id="arquivo-input-group"
                label="Arquivo Texto do Termo Aditivo do Instrumento (.pdf) *" label-for="input-arquivo" label-cols="auto"
                content-cols="12">
                <validation-provider v-if="!existeArquivo()" rules="required" v-slot="validationContext" name="arquivo">
                  <b-form-file v-model="arquivoForm" :state="getValidationState(validationContext)"
                    placeholder="Escolha um arquivo..." drop-placeholder="Solte o arquivo aqui..." class=""
                    browse-text="Escolher" accept=".pdf"></b-form-file>
                  <b-form-invalid-feedback id="input-arquivo-live-feedback">{{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </validation-provider>
                <div v-else class="d-flex justify-content-center">
                  <btn-download class="mr-2" :fazerDownload="baixarAnexo" :parametros="arquivo" />
                  <b-link class="text-dark" @click="removerArquivo()">
                    <font-awesome-icon icon="times" />
                    <div style="font-size: 12px">Remover</div>
                  </b-link>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <validation-provider rules="required" v-slot="validationContext" name="numeroAditivo">
                <b-form-group id="input-group-type" label-size="md" label="Nº Aditivo *" label-cols="auto"
                  content-cols="12">
                  <b-form-input id="input-numeroAditivo" v-model="aditivo.NrAditivoConvenio"
                    :state="getValidationState(validationContext)" type="number"></b-form-input>
                  <b-form-invalid-feedback id="input-numeroAditivo-live-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="2">
              <validation-provider rules="required" v-slot="validationContext" name="numeroAnoAditivo">
                <b-form-group id="input-group-type" label-size="md" label="Ano Aditivo *" label-cols="auto"
                  content-cols="12">
                  <b-form-input id="input-numeroAnoAditivo" v-model="aditivo.NrAnoAditivoConvenio"
                    :state="getValidationState(validationContext)" type="number"></b-form-input>
                  <b-form-invalid-feedback id="input-numeroAnoAditivo-live-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <validation-provider rules="required" v-slot="validationContext" name="justificativaAditivo">
                <b-form-group id="justificativaAditivo-input-group" label="Justificativa *"
                  label-for="input-justificativaAditivo" label-cols="auto" content-cols="12">
                  <b-form-textarea id="input-justificativaAditivo" :state="getValidationState(validationContext)"
                    v-model="aditivo.DeJustificativaAditivo" rows="3" max-rows="6"></b-form-textarea>
                  <b-form-invalid-feedback id="input-justificativaAditivo-live-feedback">{{ validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4"></b-col>
            <b-col cols="4">
              <b-form-group label-class="text-left" id="data-inicio-input-group" label="Início de vigência"
                label-for="input-data-inicio">
                <b-form-datepicker id="input-data-inicio" v-model="aditivo.DtInicioVigenciaAditivo"
                  :disabled="isVigenciaDisabled" placeholder="Selecione uma data" value-as-date
                  label-no-date-selected="Nenhuma data selecionada" reset-button label-reset-button="Limpar"
                  label-help="Use as setas para navegar pelas datas" label-prev-year="Ano anterior"
                  label-prev-month="Mês anterior" label-current-month="Mês atual" label-next-month="Próximo mês"
                  label-next-year="Próximo ano">
                </b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label-class="text-left" id="data-fim-input-group" label="Fim de vigência"
                label-for="input-data-fim">
                <b-form-datepicker id="input-data-fim" v-model="aditivo.DtFimVigenciaAditivo"
                  :disabled="isVigenciaDisabled" placeholder="Selecione uma data" value-as-date
                  label-no-date-selected="Nenhuma data selecionada" reset-button label-reset-button="Limpar"
                  label-help="Use as setas para navegar pelas datas" label-prev-year="Ano anterior"
                  label-prev-month="Mês anterior" label-current-month="Mês atual" label-next-month="Próximo mês"
                  label-next-year="Próximo ano">
                </b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <validation-provider :rules="isValorDisabled ? '' : 'required'" v-slot="validationContext"
                name="valorAditivo">
                <b-form-group id="input-group-type" label-size="md" label="Valor do Aditamento/Supressão (R$)"
                  label-cols="auto" content-cols="12">
                  <money class="form-control" id="input-valorAditivo" :disabled="isValorDisabled"
                    v-model="aditivo.VlAditivoConvenio" v-bind="vMoneyOptions"
                    :state="getValidationState(validationContext)" />
                  <b-form-invalid-feedback id="input-valorAditivo-live-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="4">
              <b-form-group label-class="text-left" rules="required" id="data-publicacao-input-group"
                label="Data de Publicação *" label-for="input-data-publicacao">
                <b-form-datepicker id="input-data-publicacao" v-model="aditivo.DtPublicacaoAditivo"
                  placeholder="Selecione uma data" value-as-date label-no-date-selected="Nenhuma data selecionada"
                  reset-button label-reset-button="Limpar" label-help="Use as setas para navegar pelas datas"
                  label-prev-year="Ano anterior" label-prev-month="Mês anterior" label-current-month="Mês atual"
                  label-next-month="Próximo mês" label-next-year="Próximo ano">
                </b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label-class="text-left" rules="required" id="data-celebracao-input-group"
                label="Data de Celebração *" label-for="input-data-celebracao">
                <b-form-datepicker id="input-data-celebracao" v-model="aditivo.DtCelebracaoAditivo"
                  placeholder="Selecione uma data" value-as-date label-no-date-selected="Nenhuma data selecionada"
                  reset-button label-reset-button="Limpar" label-help="Use as setas para navegar pelas datas"
                  label-prev-year="Ano anterior" label-prev-month="Mês anterior" label-current-month="Mês atual"
                  label-next-month="Próximo mês" label-next-year="Próximo ano">
                </b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label-class="text-left" id="data-cancelamento-input-group" label="Data de Cancelamento"
                label-for="input-data-cancelamento">
                <b-form-datepicker id="input-data-cancelamento" v-model="aditivo.DtAnulacaoAditivo"
                  placeholder="Selecione uma data" value-as-date label-no-date-selected="Nenhuma data selecionada"
                  reset-button label-reset-button="Limpar" label-help="Use as setas para navegar pelas datas"
                  label-prev-year="Ano anterior" label-prev-month="Mês anterior" label-current-month="Mês atual"
                  label-next-month="Próximo mês" label-next-year="Próximo ano" @input="handleDataAnulacaoInput">
                </b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col cols="4" v-if="isMotivoAnulacaoAvailable">
              <validation-provider v-slot="validationContext" rules="required" name="justificativaCancelamento">
                <b-form-group id="justificativaCancelamento-input-group" label="	Motivo do Cancelamento"
                  label-for="input-justificativaCancelamento" label-cols="auto" content-cols="12">
                  <b-form-textarea id="input-justificativaCancelamento" :state="getValidationState(validationContext)"
                    v-model="aditivo.DeMotivoAnulacaoAditivo" rows="3" max-rows="6"></b-form-textarea>
                  <b-form-invalid-feedback id="input-justificativaCancelamento-live-feedback">{{
                    validationContext.errors[0]
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-form>
  </validation-observer>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component';
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import BtnDownload from '@/components/shared/btn-download.vue'
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Multiselect from "vue-multiselect";
import { Money } from 'v-money'
import { store } from "@/store"
import { UtilsTS } from '@/utilsts'
import aditivosConvenioService from '@/services/licitacoes/aditivosConvenioService'
import { AditivoConvenio } from '@/types/licitacoes/aditivo-convenio/aditivo-convenio'
import { TipoTermoAditivo } from '@/types/licitacoes/tipo-termo-aditivo'
import { ArquivoAditivo } from '@/types/licitacoes/arquivo-aditivo';
import { TiposNaturezaAjusteEnum } from '@/types/licitacoes/enums/tipos-natureza-ajuste'

const CompProps = Vue.extend({
  name: 'EditarAditivoConvenio',
  components: { BtnVoltar, BtnDownload, Money, ValidationProvider, ValidationObserver, Multiselect },
  props: {
    idAditivo: {
      type: String,
      required: false
    }
  }
})

@Component
export default class EditarAditivoConvenio extends mixins(UtilsTS, CompProps) {
  listaConvenios: any[] = []
  listaTiposAditivo: TipoTermoAditivo[] = []
  listaNaturezasAjuste: any[] = []
  listaNaturezasAjusteCompleta: any[] = []
  tableBusy = false
  aditivo: AditivoConvenio = new AditivoConvenio()
  arquivo: ArquivoAditivo = new ArquivoAditivo()
  arquivoForm = null
  isVigenciaDisabled = true
  isValorDisabled = true
  isMotivoAnulacaoAvailable = false
  convenioSelecionado: any = null

  get isEdit() {
    return this.idAditivo !== undefined && this.idAditivo !== null
  }

  updateSelectConvenio() {
    this.aditivo.IdConvenio = this.convenioSelecionado.Codigo;
  }

  handleDataAnulacaoInput(): void {
    this.isMotivoAnulacaoAvailable = this.aditivo.DtAnulacaoAditivo != null
    if (!this.isMotivoAnulacaoAvailable)
      this.aditivo.DeMotivoAnulacaoAditivo = null
  }

  handleTipoNaturezaAjusteChange() {
    this.isValorDisabled = this.aditivo.IdNaturezaAjuste == TiposNaturezaAjusteEnum.AJUSTE_PRAZO ||
      this.aditivo.IdNaturezaAjuste == TiposNaturezaAjusteEnum.AJUSTE_SEM_ALTERACAO

    this.isVigenciaDisabled = this.aditivo.IdNaturezaAjuste == TiposNaturezaAjusteEnum.ACRESCIMO_VALOR ||
      this.aditivo.IdNaturezaAjuste == TiposNaturezaAjusteEnum.AJUSTE_SEM_ALTERACAO ||
      this.aditivo.IdNaturezaAjuste == TiposNaturezaAjusteEnum.SUPRESSAO_VALOR;

    if (this.isVigenciaDisabled) {
      this.aditivo.DtInicioVigenciaAditivo = null;
      this.aditivo.DtFimVigenciaAditivo = null;
    }

    if (this.isValorDisabled) {
      this.aditivo.VlAditivoConvenio = null;
    }
  }

  handleTipoAditivoChange() {
    this.isVigenciaDisabled = true
    this.isValorDisabled = true

    this.aditivo.IdNaturezaAjuste = 0

    this.listaNaturezasAjuste = this.listaNaturezasAjusteCompleta.filter(x => (x.value != TiposNaturezaAjusteEnum.ALTERACAO_CONTRATADO &&
      x.value != TiposNaturezaAjusteEnum.ALTERACAO_CONTRATADO_ACRESCIMO_VALOR &&
      x.value != TiposNaturezaAjusteEnum.ALTERACAO_CONTRATADO_SUPRESSAO_VALOR) || x.value == 0)
  }

  async mounted() {
    try {
      store.blockScreen = true

      if (this.isEdit) {
        const aditivoApi = await aditivosConvenioService.buscarAditivo(this.idAditivo)
        if (aditivoApi && aditivoApi.status === 200) {
          this.aditivo = Object.assign(this.aditivo, aditivoApi.data)
          this.aditivo.tratarDadosDaAPI()
          this.arquivo = this.aditivo.ArquivoAditivoConvenio.length > 0 ? Object.assign(this.arquivo, this.aditivo.ArquivoAditivoConvenio[0]) : new ArquivoAditivo()
          this.handleTipoNaturezaAjusteChange()
          this.handleDataAnulacaoInput()
        } else {
          this.$router.push("/modulo-licitacoes/aditivos-convenios");
          this.$toast.error(aditivoApi.data.msg || "Erro ao carregar aditivo");
        }
      }
      else {
        this.aditivo.IdConvenio = 0
        this.aditivo.IdNaturezaAjuste = 0
        this.aditivo.ArquivoAditivoConvenio = []
      }
      const responseConvenios = await aditivosConvenioService.listarConvenios()
      //const responseTiposAditivo = await aditivosConvenioService.listarTiposAditivo()
      const responseNaturezasAjuste = await aditivosConvenioService.listarNaturezasAjuste()
      this.listaConvenios = [...responseConvenios.data.map(c => {
        const limiteDescricao = 70
        const descricaoConvenio = c.DeObjetoConvenio.length > limiteDescricao ? c.DeObjetoConvenio.substring(0, limiteDescricao) + "..." : c.DeObjetoConvenio
        return { Codigo: c.IdConvenio, Nome: `${c.NrConvenio}/${c.NrAnoConvenio} - ${descricaoConvenio}` }
      }
      )]

      if (this.isEdit) {
        this.convenioSelecionado = this.listaConvenios.find(x => x.Codigo === this.aditivo.IdConvenio)
      }

      //this.listaTiposAditivo = [{ value: 0, text: 'SELECIONE UMA OPÇÃO', disabled: true }, ...responseTiposAditivo.data.map(t => ({ value: t.IdTipoTermoAditivo, text: t.DeTipoTermoAditivo }))]
      this.listaNaturezasAjuste = [{ value: 0, text: 'SELECIONE UMA OPÇÃO', disabled: true }, ...responseNaturezasAjuste.data.map(t => ({ value: t.IdNaturezaAjuste, text: t.DeNaturezaAjuste }))]
      this.listaNaturezasAjusteCompleta = this.listaNaturezasAjuste

      this.listaNaturezasAjuste = this.listaNaturezasAjusteCompleta.filter(x => (x.value != TiposNaturezaAjusteEnum.ALTERACAO_CONTRATADO &&
        x.value != TiposNaturezaAjusteEnum.ALTERACAO_CONTRATADO_ACRESCIMO_VALOR &&
        x.value != TiposNaturezaAjusteEnum.ALTERACAO_CONTRATADO_SUPRESSAO_VALOR) || x.value == 0)

    } catch (e: any) {
      console.error('Erro ao montar edição de aditivo de convenio', e)
      this.$router.push("/modulo-licitacoes/aditivos-convenios");
      this.$toast.error(e.message || "Erro ao carregar aditivo de convenio");
    } finally {
      store.blockScreen = false
    }
  }

  getValidationState({ dirty, validated, valid = null }): any {
    return dirty || validated ? valid : null;
  }

  existeArquivo() {
    return this.arquivo.IdAditivoConvenio > 0 ? true : false
  }

  async removerArquivo() {
    this.arquivo = new ArquivoAditivo()
  }

  async baixarAnexo(arquivo: ArquivoAditivo) {
    const response = await aditivosConvenioService.baixarAnexo(arquivo.IdArquivo)
    this.download(arquivo.DeNomeArqTextoAditivo, response.data)
  }
  async salvarAditivo() {
    try {
      const response = this.isEdit ? await aditivosConvenioService.editarAditivo(this.aditivo, this.arquivoForm) : await aditivosConvenioService.adicionarAditivo(this.aditivo, this.arquivoForm)
      if (response && response.status === 200) {
        this.$toast.success('Aditivo salvo com sucesso.')
        this.$router.push('/modulo-licitacoes/aditivos-convenios-outros-instrumentos-congeneres')
      }
      else if (response && [400,403].includes(response.status) && response.data.erros) {
        response.data.erros.forEach(erro => {
          this.$toast.error(erro, {
            timeout: false
          });
        });
      }
      else {
        throw new Error(response.data && response.data.msg ? response.data.msg : 'Erro ao salvar aditivo.')
      }
    } catch (e: any) {
      console.error(e)
      this.$toast.error(e.message ? e.message : e);
    }
  }
};
</script>

<style>
#input-group-selectConvenio {
  padding: 0;
  padding-top: 2% !important;
}

#input-group-selectConvenio .multiselect {
  width: 100%;
  max-width: 100%;
}

#input-group-selectConvenio .multiselect__tags {
  border: #ced4da solid 1px !important;
  border-radius: 3px !important;
}

#input-group-selectConvenio .multiselect__option {
  padding: 6px !important;
  min-height: 0;
  font-size: 16px;
}

#input-group-selectConvenio .multiselect__option--selected {
  color: #495057 !important;
  background: #fff;
  font-weight: 400;
}

#input-group-selectConvenio .multiselect__content-wrapper {
  border: 1px solid #ced4da;
  max-height: 200px !important;
}

#input-group-selectConvenio .multiselect__option--highlight {
  background: #007bff !important;
  color: #fff !important;
}

#input-group-selectConvenio .multiselect__input,
.multiselect__single {
  background-color: #fff !important;
  color: #495057 !important;
}

#input-group-selectConvenio .multiselect__input::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #495057 !important;
}

#input-group-selectConvenio .multiselect__input::active {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  border: none;
}

#input-group-selectConvenio .multiselect__tags {
  background-color: #fff;
  color: #495057 !important;
  border-radius: 2px;
}

#input-group-selectConvenio .multiselect__select:before {
  color: #495057 !important;
  border-color: #495057 transparent transparent !important;
}

#input-group-selectConvenio .multiselect {
  z-index: 2;
}

#input-group-selectConvenio .multiselect__placeholder {
  color: #495057;
  font-weight: 400;
  font-size: 1rem;
}

#input-group-selectConvenio .multiselect__single {
  cursor: pointer;
}

#input-group-selectConvenio .multiselect__input,
#input-group-selectConvenio .multiselect__single {
  vertical-align: initial;
}

#input-group-selectConvenio .multiselect--disabled .multiselect__tags,
#input-group-selectConvenio .multiselect--disabled .multiselect__tags span {
  color: #6c757d !important;
}

#input-group-selectConvenio .multiselect--disabled .multiselect__select {
  background: #fff !important;
}

#convenioSelectWrapper.invalid .multiselect__tags {
  border: #dc3545 solid 1px !important;
  border-radius: 3px !important;
}

#convenioSelectWrapper.valid .multiselect__tags {
  border: #28a745 solid 1px !important;
  border-radius: 3px !important;
}

#convenioSelectWrapper label {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  text-align: left;
}
</style>